<template>
    <div class="container pt-2">
        <PageTitle icon="fa fa-address-card" main="Jobs em execução" sub="Verificar dados e finalizar Jobs em execução" />
        <!-- FINALIZAÇÃO -->
        <b-modal id="modal-finaliza" hide-footer>
            <template v-slot:modal-title>
                Finalização do Serviço:
            </template>
            <div class="d-block text-center">
            <b-form>
                <div class="row justify-content-md-center">
                    <div class="col-md-12">
                        <b-form-group label="Resultado:" label-for="finaliza-resultado">
                            <b-form-file
                                id="finaliza-resultado"
                                placeholder="Escolha o arquivo ou arraste aqui..."
                                drop-placeholder="Arraste aqui..."></b-form-file>
                        </b-form-group>
                    </div>
                </div>
                <div class="row justify-content-md-center mb-3">
                    <div class="col-md-12">
                        <div>Arquivo Selecionado: {{ finaliza.resultado ? finaliza.resultado : '' }}</div>
                    </div>
                </div>
            </b-form>
            </div>
            <b-button variant="success" class="mt-3" block @click="setFinaliza">Enviar Resultado</b-button>
        </b-modal>
        <!-- VISUALIZA -->
        <b-modal id="modal-visualiza" hide-footer>
            <template v-slot:modal-title>
                Verifique os dados do Serviço:
            </template>
            <div class="d-block text-center">
                <p><b>Número do Processo: </b>{{ job.numero }}</p>
                <p><b>Descrição: </b>{{ job.descricao }}</p>
                <p><b>Categoria: </b>{{ job.categoria_titulo }}</p>
                <p><b>Subcategoria: </b>{{ job.subcategoria_titulo }}</p>
                <p><b>Tipo de Serviço: </b>{{ job.id_tiposervico_titulo }}</p>
                <p><b>Data de publicação: </b>{{ job.dataPublicacao }}</p>
                <p><b>Prazo: </b>{{ job.id_tiposervico_prazo }} dias</p>
                <hr>
                <p><b>Quem publicou: </b>{{ job.quemPublicou_nome }}</p>
                <p><b>Data da postagem: </b>{{ job.dataPostagem }}</p>
                <hr>
                <p><b>UF: </b>{{ job.uf }}</p>
                <p><b>Cidade: </b>{{ job.cidade }}</p>
                <p><b>Vara: </b>{{ job.vara }}</p>
                <hr>
                <p><b>Segredo de Justiça: </b>{{ job.segredoJustica==="sim" ? "Sim" : "Não"}}</p>
                <hr>
                <p><b>Status: </b>{{ job.status==="RETORNADO" ? "Retornado" : "Em Execução" }}</p>
            </div>
            <b-button variant="danger" class="mt-3" block @click="$bvModal.hide('modal-visualiza')">Fechar</b-button>
        </b-modal>
        <!-- ANEXOS -->
        <b-modal id="modal-anexos" hide-footer>
            <template v-slot:modal-title>
                Anexos do Job:
            </template>
            <div class="d-block text-center">
                <p v-if="filejob.descricao01!==''"><b>Descrição 01: </b>{{ filejob.descricao01 }}</p>
                <p v-if="filejob.descricao01!==''"><b>Arquivo 01: </b><a target="_blank" :href="filejob.arquivo01">Clique Aqui</a></p>
                <hr v-if="filejob.descricao01!==''">
                <p v-if="filejob.descricao02!==''"><b>Descrição 02: </b>{{ filejob.descricao02 }}</p>
                <p v-if="filejob.descricao02!==''"><b>Arquivo 02: </b><a target="_blank" :href="filejob.arquivo02">Clique Aqui</a></p>
                <hr v-if="filejob.descricao02!==''">
                <p v-if="filejob.descricao03!==''"><b>Descrição 03: </b>{{ filejob.descricao01 }}</p>
                <p v-if="filejob.descricao03!==''"><b>Arquivo 03: </b><a target="_blank" :href="filejob.arquivo03">Clique Aqui</a></p>
                <hr v-if="filejob.descricao03!==''">
                <p v-if="filejob.descricao04!==''"><b>Descrição 04: </b>{{ filejob.descricao01 }}</p>
                <p v-if="filejob.descricao04!==''"><b>Arquivo 04: </b><a target="_blank" :href="filejob.arquivo04">Clique Aqui</a></p>
                <hr v-if="filejob.descricao04!==''">
                <p v-if="filejob.descricao05!==''"><b>Descrição 05: </b>{{ filejob.descricao01 }}</p>
                <p v-if="filejob.descricao05!==''"><b>Arquivo 05: </b><a target="_blank" :href="filejob.arquivo05">Clique Aqui</a></p>
                <hr v-if="filejob.descricao05!==''">
            </div>
            <b-button variant="danger" class="mt-3" block @click="$bvModal.hide('modal-anexos')">Fechar</b-button>
        </b-modal>
        <div :style="{ overflow: overflowValue, width: larguraTela + 'px' }" v-if="larguraTela<721">
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-jobs" 
                class="text-center table table-sm" 
                :items="jobs" 
                :fields="fields" 
                per-page="3"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(template_status)="data">
                    {{ data.item.status==="RETORNADO" ? "Retornado" : "Em Execução" }}
                </template>
                <template v-slot:cell(actions)="data">
                    <b-button variant="success" class="mr-2 btn-sm mb-1" @click="openFinaliza(data.item)"
                        v-if="(data.item.status==='AGUARDANDO FINALIZACAO' || 
                        data.item.status==='RETORNADO') && 
                        (nivel==='admin' || nivel==='ambos' || nivel==='prestador')">
                        <font-awesome-icon :icon="['fa', 'file-import']"/>
                    </b-button>
                    <b-button variant="info" class="mr-2 btn-sm mb-1" @click="openVisualiza(data.item)"
                        v-if="(data.item.status==='AGUARDANDO FINALIZACAO' || 
                        data.item.status==='RETORNADO') && 
                        (nivel==='admin' || nivel==='ambos' || nivel==='prestador')">
                        <font-awesome-icon :icon="['fa', 'eye']"/>
                    </b-button>
                    <b-button variant="warning" class="mr-2 btn-sm mb-1 text-white" @click="openAnexos(data.item)"
                        v-if="(data.item.status==='AGUARDANDO FINALIZACAO' || 
                        data.item.status==='RETORNADO') && 
                        (nivel==='admin' || nivel==='ambos' || nivel==='prestador')">
                        <font-awesome-icon :icon="['fa', 'archive']"/>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                per-page="3"
                aria-controls="table-jobs"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
        <div v-else>
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-jobs" 
                class="text-center table table-sm" 
                :items="jobs" 
                :fields="fields" 
                per-page="3"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(template_status)="data">
                    {{ data.item.status==="RETORNADO" ? "Retornado" : "Em Execução" }}
                </template>
                <template v-slot:cell(actions)="data">
                    <b-button variant="success" class="mr-2 btn-sm mb-1" @click="openFinaliza(data.item)"
                        v-if="(data.item.status==='AGUARDANDO FINALIZACAO' || 
                        data.item.status==='RETORNADO') && 
                        (nivel==='admin' || nivel==='ambos' || nivel==='prestador')">
                        <font-awesome-icon :icon="['fa', 'file-import']"/>
                    </b-button>
                    <b-button variant="info" class="mr-2 btn-sm mb-1" @click="openVisualiza(data.item)"
                        v-if="(data.item.status==='AGUARDANDO FINALIZACAO' || 
                        data.item.status==='RETORNADO') && 
                        (nivel==='admin' || nivel==='ambos' || nivel==='prestador')">
                        <font-awesome-icon :icon="['fa', 'eye']"/>
                    </b-button>
                    <b-button variant="warning" class="mr-2 btn-sm mb-1 text-white" @click="openAnexos(data.item)"
                        v-if="(data.item.status==='AGUARDANDO FINALIZACAO' || 
                        data.item.status==='RETORNADO') && 
                        (nivel==='admin' || nivel==='ambos' || nivel==='prestador')">
                        <font-awesome-icon :icon="['fa', 'archive']"/>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                per-page="3"
                aria-controls="table-jobs"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    name: 'finalizaJobs',
    components: { PageTitle },
    data: function() {
        return {
            jwt: new VueEasyJwt(),
            nivel: '',
            job: {},
            jobs: [],
            filejob: {},
            finaliza: {},
            quemRecebeu: '',
            exibeRodape: true,
            currentPage: 1,
            filtro: null,
            filtrando: [],
            totalRows: 1,
            fields: [
                { key: 'numero', label: 'Número', sortable: true },
                { key: 'dataPublicacao', label: 'Data de Publicação', sortable: true, formatter: 'formatData' },
                { key: 'id_tiposervico_datavalidade', label: 'Data Limite', sortable: true, formatter: 'formatData' },
                { key: 'template_status', label: 'Status', sortable: true },
                { key: 'actions', label: 'Ações', thStyle: { width: '20%' }  }
            ],
            larguraTela: 0,
            overflowValue: 'auto'
        }
    },
    computed: {
        rows() {
            return this.jobs.length
        }
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        openFinaliza(job) {
            this.job = job
            this.$bvModal.show('modal-finaliza')
        },
        openAnexos(job) {
            const url = `${baseApiUrl}/backend/SELECT/arquivo_job.php?job=${job.id}`
            axios.get(url).then(res => {
                this.filejob = res.data[0]
            }).catch(
                (e) => {
                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
            })

            this.$bvModal.show('modal-anexos')
        },
        openVisualiza(job) {
            this.job = job
            this.$bvModal.show('modal-visualiza')
        },
        setFinaliza() {
            this.finaliza.id = this.job.id
            this.finaliza.resultado = document.getElementById('finaliza-resultado').value
            axios['put'](`${baseApiUrl}/backend/GENERAL/finalizaJob.php?id=${this.finaliza.id}`, this.finaliza)
            .then(() => {
                this.$bvModal.hide('modal-finaliza')
                this.$toasted.global.defaultSuccess({ message : 'Serviço finalizado com sucesso!' })
                this.reset()
            })
            .catch(
                (e) => {
                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
            })
        },
        formatData(value) {
            const arr = value.split('-')
            const y = arr[0]
            const m = arr[1]
            const d = arr[2]
            return `${d}/${m}/${y}`
        },
        loadJobs() {
            axios.get(`${baseApiUrl}/backend/SELECT/finalizaJobs.php`).then(res => {
                this.jobs = res.data
                this.exibeRodape = false
            }).catch(
                (e) => {
                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                this.exibeRodape = true
            })
        },
        reset() {
            this.job = {}
            this.filejob = {}
            this.loadJobs()
        },
        loadJob(job) {
            this.job = { ...job }
        },
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.nivel = decodedToken['data'].nivel
                this.quemRecebeu = decodedToken['data'].id
            }
        }
    },
    mounted() {
        this.validaLogin()
        if(this.nivel === 'fornecedor') {
            this.$router.push('/')
        }
        this.loadJobs()
        this.larguraTela = screen.width - (screen.width * 0.08)
        this.totalRows = this.jobs.length
    }
}
</script>

<style>
.table {
    font-size: 0.9rem;
}

.text-custom {
    font-size: 0.8rem;
}
</style>